import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=58596800&scoped=true&"
import script from "./DocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=58596800&lang=scss&scoped=true&"
import style1 from "./DocumentEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58596800",
  null
  
)

export default component.exports